const version = {
    name: 'dev 2c7b57fd',
    domain: 'esptool.spacehuhn.com',
}

export default version